/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaUser: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="user" viewBox="0 0 15 15">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="navigation-ToDo"
          transform="translate(-232.000000, -32.000000)"
          fill="currentColor"
        >
          <g id="Group-25">
            <g id="Group-21" transform="translate(230.000000, 29.000000)">
              <g id="Group-24">
                <g id="user" transform="translate(0.000000, 2.000000)">
                  <path
                    d="M14,14 C14,14.3681898 13.7015232,14.6666667 13.3333333,14.6666667 C12.9651435,14.6666667 3.0348565,14.6666667 2.66666667,14.6666667 C2.29847683,14.6666667 2,14.3681898 2,14 L2,12.6666667 C2,10.8257175 3.49238417,9.33333333 5.33333333,9.33333333 L10.6666667,9.33333333 C12.5076158,9.33333333 14,10.8257175 14,12.6666667 L14,14 Z M8,8 C6.15905083,8 4.66666667,6.50761583 4.66666667,4.66666667 C4.66666667,2.8257175 6.15905083,1.33333333 8,1.33333333 C9.84094917,1.33333333 11.3333333,2.8257175 11.3333333,4.66666667 C11.3333333,6.50761583 9.84094917,8 8,8 Z"
                    id="Shape"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaUser)
